export default "__VITE_ASSET__BFghD_WU__"